'use client'

import LandingBodyClass from '@/app/landing/LandingBodyClass'
import { LandingLoginProvider } from '@/app/landing/LandingLoginProvider'
import { LandingNavWithLogin } from '@/app/landing/LandingNavWithLogin'
import { LandingPricing } from '@/app/landing/components/LandingPricing'
import { LandingPricingSection } from '@/app/landing/components/LandingPricingSection'
import { LandingFooter } from '@/app/landing/LandingFooter'
import { NewUINav } from '@/app/landing/components/NewUINav'
import { NewUISinglePlans } from '@/app/landing/components/NewUISinglePlans'
import { NewUIComboPlans } from '@/app/landing/components/NewUIComboPlans'
import { NewUIFooter } from '@/app/landing/components/NewUIFooter'
import { PAYMENTS_ENABLED, TF_ENABLE_COMBO_PLAN } from '@/lib/config'
import { TF_SHOW_NEW_UI_LANDING_PAGE } from '@/lib/featureFlags'
import legacyStyles from '@/app/landing/landing.module.css'
import newStyles from '@/app/landing/newLanding.module.css'

// Imported statically rather than with `dynamic(..., { ssr: false })` as the landing page does:
// on its own URL the pricing copy has to exist in the HTML, both for crawlers and so the page is
// not blank until a client chunk arrives.

/**
 * The landing page's pricing section, on its own URL.
 *
 * Both landing variants are mirrored behind the same feature flag the home page uses, so /pricing
 * never drifts from whichever one is live. The sections are deliberately NOT wrapped in
 * `TrackedLandingSection`: that would report section views against the landing funnel and inflate
 * it with traffic that never visited /.
 */
export function PricingPageContent() {
  if (TF_SHOW_NEW_UI_LANDING_PAGE) {
    return (
      <LandingLoginProvider>
        <LandingBodyClass />
        <div className={newStyles.root}>
          <NewUINav stickyMenu />
          <NewUISinglePlans />
          <NewUIComboPlans />
          <NewUIFooter />
        </div>
      </LandingLoginProvider>
    )
  }

  return (
    <>
      <LandingBodyClass />
      <LandingLoginProvider>
        <main className={legacyStyles.landingRoot}>
          <LandingNavWithLogin />
          <div className={legacyStyles.sectionShell}>
            <div className={legacyStyles.pricingSectionInner}>
              <div aria-hidden className={legacyStyles.pricingBgGradient} />
              <LandingPricing />
            </div>
          </div>
          {PAYMENTS_ENABLED && TF_ENABLE_COMBO_PLAN ? (
            <div className={legacyStyles.sectionShell}>
              <LandingPricingSection />
            </div>
          ) : null}
          <LandingFooter />
        </main>
      </LandingLoginProvider>
    </>
  )
}
